import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatIDR(n) {
  if (n === null || n === undefined || isNaN(n)) return 'Rp 0';
  // Rupiah tidak punya satuan sen — bulatkan supaya tidak ada ",xxx" di UI.
  return 'Rp ' + Math.round(Number(n)).toLocaleString('id-ID');
}

export function formatDate(iso) {
  if (!iso) return '-';
  const d = new Date(iso);
  return d.toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateTime(iso) {
  if (!iso) return '-';
  const d = new Date(iso);
  return d.toLocaleString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function waLink(phone, message) {
  const p = String(phone || '').replace(/\D/g, '');
  const withCountry = p.startsWith('0') ? '62' + p.slice(1) : p;
  return `https://wa.me/${withCountry}?text=${encodeURIComponent(message)}`;
}

export function renderTemplate(template, vars) {
  return Object.keys(vars).reduce(
    (acc, key) => acc.replaceAll(`{${key}}`, vars[key] ?? ''),
    template || ''
  );
}
